/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-01 10:24:37
 * @Description: 
 */
import axios from "axios"
import urls from "src/constant/url";


const instance = axios.create({
  //创建axios实例，在这里可以设置请求的默认配置
  timeout: 60000, // 设置超时时间10s
  withCredentials: true,
})

/** 添加请求拦截器 **/
instance.interceptors.request.use(
  (config: any) => {
    config.headers['Content-Type'] = config.headers['Content-Type']
      ? config.headers['Content-Type']
      : 'application/x-www-form-urlencoded'
    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)
export const loadSource = ({ url }: {url: string}) => {
  return axios({
    baseURL: process.env.PUBLIC_URL,
    url,
  }).then((res: any)=> res.data)
}

export const loadEffectList = ({ url }: {url: string}) => {
  return axios({
    baseURL: process.env.PUBLIC_URL,
    url,
  }).then((res: any)=> res.data)
}

export const FTGetSubscriptions = () => {
  return instance.get(`${urls.baseUrl}api/app/payment/subscriptions`,{
    headers: {
      'x-app-id': "app-fotor-web",
    }
  }).then(res => {
    return res.data;
  });
}

export const FTGetAdShowCountry = () => {
  let url = `${urls.baseUrl}a8s/api/v1/fotor/a8s/3rd/block?position=editorTool`;
  return instance.get(url, {
    headers: { "x-app-id": "app-fotor-web" } //设置header信息
  }).then(res => {
    return res.data;
  });;
}

export const FTGetLoop = (taskId: string) => {
	return instance
		.get(`${urls.baseUrl}api/create/goart-effects/${taskId}`, {
			headers: {
				'x-app-id': 'app-fotor-web',
			},
		})
		.then(res => {
			return res.data;
		});
};



export const FTGetImageUrl = (mimeType: string = 'jpg') => {
	return instance
		.get(`${urls.baseUrl}api/create/sign?mimeType=${mimeType}`, {
			headers: {
				'x-app-id': 'app-fotor-web',
			},
		})
		.then(res => {
			return res.data;
		});
};



export const FTGetAiArtImage = (params:{img:string,templateId:string,googleToken:string,googleAction:string}) => {
  let url = `${urls.baseUrl}api/create/goart-effects`;
  return instance.post(url, params,{
    headers: { "x-app-id": "app-fotor-web",'Content-Type': 'application/json' } //设置header信息
  }).then(res => {
    return res.data;
  });;
}





export const FTGetUserPanelType = () => {
  return instance
    .get(`${urls.baseUrl}pay/service/en/payment/pre-activity`)
    .then(res => {
      return res.data;
    });
}

//用户行为分析


export const FTUserProfile = (id:string) => {
  return instance
    .put(`${urls.baseUrl}api/user-profile/v1/tool`,{toolId:id},{
      headers: { 'Content-Type': 'application/json' ,"x-app-id": "app-fotor-web",} //设置header信息
    })
    .then(res => {
      return res.data;
    });
}